import { v4 as uuidv4 } from 'uuid';
import { CultureTextModel } from './form';
import { formatMessageByCulture } from '../../utilities/CultureUtilities';

export class Product {
  public price: number;
  public description: CultureTextModel[] | string;
  public text: CultureTextModel[] | string;
  public value: string;
  public min: number | undefined;
  public max: number | undefined;
  public limit: number | undefined;
  public isHidden?: boolean = false;

  constructor(cultures: string[]) {
    this.value = uuidv4();
    this.price = 0;

    this.text = [];
    this.description = [];
    this.min = undefined;
    this.max = undefined;
    this.limit = undefined;
    this.isHidden = false;

    for (const culture of cultures) {
      this.text.push({ culture, value: formatMessageByCulture('toolbox.labels.product', culture) });
      this.description.push({ culture, value: '' });
    }
  }
}
